// extracted by mini-css-extract-plugin
export var label = "_9c-1";
export var reminder = "_9c-0";